import request from '../../../common/utils/request';
import { toLowerCase } from '../../../common/utils/params';

const enquire = values =>
  request('post', `/enquire_messages`, { enquire_message: { ...toLowerCase(values) } });

export default { enquire };



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/utils/api/contact.js